// extracted by mini-css-extract-plugin
module.exports = {"graph":"case-study-module--graph--3-ukD","meta":"case-study-module--meta--NRYLq","label":"case-study-module--label--3qko8","value":"case-study-module--value---A3Lx"};